import React, { useContext } from 'react';
import PricingContext from '../../../context/pricing';

const PlanComparisonLink = () => {
  const { state } = useContext(PricingContext);

  const cacheBuster =
    process.env.NODE_ENV === 'production' ? new Date().getTime() : '';

  return (
    <div className="mobile-comparison-container m-top-8 p-all-3 p-bottom-5 text-center border-radius bg-blue-lightest d-none-desktop">
      <a
        href={
          state.activeTab === 'e'
            ? 'https://sendgrid.com/wp-content/uploads/pdf/Twilio-SendGrid-API-Plan-Comparison-061622.pdf'
            : `/files/Twilio-SendGrid-Marketing-Campaigns-Plan-Comparison.pdf?ver=${cacheBuster}`
        }
        download
        className="arrow-link download"
      >
        Compare all Features
      </a>
    </div>
  );
};

export default PlanComparisonLink;
